import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LiveChat } from "@/components/LiveChat";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import BlogPage from "@/pages/BlogPage";
import ContactPage from "@/pages/ContactPage";
import ConsultationPage from "@/pages/ConsultationPage";
import ClientLoginPage from "@/pages/ClientLoginPage";
import ClientDashboard from "@/pages/ClientDashboard";
import InvoicePaymentPage from "@/pages/InvoicePaymentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

// Layout wrapper to conditionally show navbar/footer
function Layout({ children }) {
  const location = useLocation();
  const isPortalPage = location.pathname.startsWith("/portal") || location.pathname.startsWith("/admin");

  return (
    <>
      {!isPortalPage && <Navbar />}
      <main>{children}</main>
      {!isPortalPage && <Footer />}
      {!isPortalPage && <LiveChat />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* Public Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/consultation" element={<ConsultationPage />} />
            <Route path="/schedule" element={<ConsultationPage />} />
            
            {/* Client Portal */}
            <Route path="/portal" element={<ClientLoginPage />} />
            <Route path="/portal/dashboard" element={<ClientDashboard />} />
            <Route path="/portal/invoices/:invoiceId" element={<InvoicePaymentPage />} />
            <Route path="/portal/payment/success" element={<PaymentSuccessPage />} />
            
            {/* Admin Portal */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </Layout>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#121212',
              color: '#FFFFFF',
              border: '1px solid #2A2A2A',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
